import { z } from 'zod';
export const oxygenSafetyValidationSchema = z.object({
    id: z.string(),
    data: z.object({
        // Section 1: Physician Order Verification
        orderDate: z.string().min(1, 'required'),
        orderingPhysicianId: z.string().default(''),
        mdPhone: z.string().default(''),
        lpm: z.string().default(''),
        deliveryDevice: z.string().default(''),
        frequency: z.string().default(''),
        targetSpO2: z.string().default(''),
        diagnosisCode: z.string().default(''),
        diagnosisDesc: z.string().default(''),
        orderMatchesUse: z.string().min(1, 'required'),
        discrepancyNotes: z.string().default(''),
        // Section 2: Equipment Assessment
        concentrator: z.boolean().default(false),
        concentratorBrand: z.string().default(''),
        concentratorSerial: z.string().default(''),
        concentratorCondition: z.string().default(''),
        portableTank: z.boolean().default(false),
        tankSize: z.string().default(''),
        tankPSI: z.string().default(''),
        liquidO2: z.boolean().default(false),
        deliveryDeviceType: z.string().default(''),
        tubingLength: z.string().default(''),
        tubingCondition: z.string().default(''),
        humidifierUsed: z.string().default(''),
        humidifierClean: z.string().default(''),
        dmeVendor: z.string().default(''),
        dmePhone: z.string().default(''),
        lastServiceDate: z.string().default(''),
        nextServiceDate: z.string().default(''),
        equipmentNotes: z.string().default(''),
        // Section 4: Respiratory Assessment & Vital Signs
        spo2OnO2: z.string().min(1, 'required'),
        spo2OffO2: z.string().default(''),
        hr: z.string().default(''),
        rr: z.string().default(''),
        bp: z.string().default(''),
        breathSounds: z.string().default(''),
        accessoryMuscles: z.string().default(''),
        cyanosis: z.string().default(''),
        edema: z.string().default(''),
        cough: z.string().default(''),
        sputum: z.string().default(''),
        narrativeResp: z.string().default(''),
        // Section 5: Fire Safety Checklist — Safety Measures (pass)
        safetyNoSmokingSignsPosted: z.boolean().default(false),
        safetySmokingAway: z.boolean().default(false),
        safetyNoOpenFlames: z.boolean().default(false),
        safetyOxygenAwayFromHeat: z.boolean().default(false),
        safetyTanksSecured: z.boolean().default(false),
        safetyNoOilGrease: z.boolean().default(false),
        safetyElectricalSafety: z.boolean().default(false),
        safetySmokeDetectors: z.boolean().default(false),
        safetyFireExtinguisher: z.boolean().default(false),
        safetyTubingNotTripping: z.boolean().default(false),
        safetyVentilatedArea: z.boolean().default(false),
        safetyBackupTankAvailable: z.boolean().default(false),
        // Section 5: Fire Safety Checklist — Hazards Identified (fail)
        hazardPatientSmokes: z.boolean().default(false),
        hazardOthersSmoke: z.boolean().default(false),
        hazardSmokingNearO2: z.boolean().default(false),
        hazardOpenFlamesNearO2: z.boolean().default(false),
        hazardOilBasedProducts: z.boolean().default(false),
        hazardImproperStorage: z.boolean().default(false),
        hazardNoSmokeDetectors: z.boolean().default(false),
        // Section 6: Patient/Caregiver Education
        eduReviewedWith: z.string().min(1, 'required'),
        eduReviewDate: z.string().default(''),
        eduNoSmokingRule: z.boolean().default(false),
        eduProperStorage: z.boolean().default(false),
        eduOilFreeProducts: z.boolean().default(false),
        eduEmergencyPlan: z.boolean().default(false),
        eduBackupPlan: z.boolean().default(false),
        eduWhenToCall911: z.boolean().default(false),
        eduEquipmentUse: z.boolean().default(false),
        eduTubingCare: z.boolean().default(false),
        eduTravelWithO2: z.boolean().default(false),
        eduConservingTips: z.boolean().default(false),
        eduSignsOfHypoxia: z.boolean().default(false),
        eduSignsOfO2Toxicity: z.boolean().default(false),
        eduVerbalizesUnderstanding: z.boolean().default(false),
        eduRefusedEducation: z.boolean().default(false),
        eduEducationBarriers: z.string().default(''),
        eduAdditionalNotes: z.string().default(''),
        // Section 7: Care Plan
        carePlanAdditionalInterventions: z.string().default(''),
        carePlanPatientGoal: z.string().default(''),
        carePlanReassessDate: z.string().default(''),
    }),
    signedUserId: z.string().min(1, 'required'),
    signedUserDate: z.string().min(1, 'required'),
});
